import qs from 'query-string';

import { tokenToUserConverter } from './tokenConverter';

export const parseUserHash = (userHash: string) => {
    const qsUser = qs.parse(userHash);
    const user = tokenToUserConverter(qsUser['access_token']?.toString() ?? '');
    return user;
};
